import { Box, Typography } from '@mui/material';
import { useRef } from 'react';
import { Cell, Pie, PieChart as RechartsPieChart, Tooltip } from 'recharts';
import { getDisabledSectorColor } from '../../utils';
import { PieActiveShape } from '../PieActiveShape';

type Props = {
  title: string;
  radius: number;
  chartWidth?: number;
  numberOfElements?: number;
};

type DataElement = {
  value: number;
};

export const PieChart = ({ title, radius, chartWidth = 20, numberOfElements = 5 }: Props) => {
  const ref = useRef<HTMLElement | null>(null);
  const data: DataElement[] = Array(numberOfElements)
    .fill('')
    .map(() => ({ value: Math.ceil(Math.random() * 10) }));

  const diameter = 2 * radius;

  return (
    <Box
      ref={ref}
      sx={{
        display: 'inline-block',
        width: `${diameter + 10}px`,
        height: `${diameter + 10}px`,
      }}
    >
      <RechartsPieChart margin={{ top: 0, left: 0, right: 0, bottom: 0 }} width={diameter + 10} height={diameter + 10} aria-label={title}>
        <Pie
          cx={'50%'}
          cy={'50%'}
          innerRadius={radius - chartWidth}
          outerRadius={radius}
          data={data}
          dataKey="value"
          nameKey="value"
          animationBegin={0}
          animationDuration={500}
          activeShape={PieActiveShape}
          blendStroke
          aria-hidden={true}
          rootTabIndex={-1}
        >
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={getDisabledSectorColor(index)} />
          ))}
        </Pie>

        <Tooltip
          position={{ x: 0, y: 0 }}
          wrapperStyle={{
            height: diameter + 10,
            width: diameter + 10,
            visibility: 'visible',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            flexDirection: 'column',
          }}
          content={() => (
            <>
              <Typography variant="caption">------</Typography>
              <Typography variant="h4" component={'div'} sx={{ lineHeight: 1 }}>
                --
              </Typography>
            </>
          )}
        />
      </RechartsPieChart>
    </Box>
  );
};
